import { noticeError } from 'core/utilities/helpers/notice-error';

export const copyToClipboard = async (url: string) => {
  try {
    await navigator.clipboard.writeText(url);
  } catch (err) {
    const data = {
      error: err,
    };
    noticeError('click-copy-error', data);
  }
};
